import {
  getFirestore,
  collection,
  doc,
  onSnapshot,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./payrate_setting.type";

const firestore = getFirestore(app);

let payrateSub = [];

export const snapPayrateSettings = (callback) => (dispatch) => {
  dispatch({ type: TYPES.SNAP_PAYRATE_SETTINGS_REQUEST });
  const cRef = collection(firestore, REF.PAYRATE_SETTING);
  const unsub = onSnapshot(cRef, (snapshot) => {
    const data = {};
    snapshot.docs.forEach((d) => {
      data[d.id] = d.data();
    });
    dispatch({ type: TYPES.SNAP_PAYRATE_SETTINGS_SUCCESS, payload: data });
    if (callback) callback(data);
  });
  payrateSub.push(unsub);
};

export const unSnapPayrateSettings = () => (dispatch) => {
  payrateSub.forEach((sub) => sub());
  payrateSub.length = 0;
};

export const savePayrateSetting =
  ({ staffId, data }, callback) =>
  (dispatch) => {
    const payload = { ...data, updateAt: serverTimestamp() };
    const dRef = doc(firestore, REF.PAYRATE_SETTING, staffId);
    setDoc(dRef, payload, { merge: true }).then(() => {
      dispatch({
        type: TYPES.SAVE_PAYRATE_SETTING_SUCCESS,
        payload: { staffId, data: payload },
      });
      if (callback) callback();
    });
  };
